<template>
  <button class="skb-back-button" :class="[theme, { disabled }]" :disabled="disabled">
    <img v-if="icon && iconPosition === 'left'" class="left" :src="icon" />
    <slot />
    <img v-if="icon && iconPosition === 'right'" class="right" :src="icon" />
  </button>
</template>

<script>
export default {
  name: 'SKBButton',
  props: {
    icon: {
      type: String,
      default: null
    },
    iconPosition: {
      type: String,
      default: 'right'
    },
    theme: {
      type: String,
      default: 'primary'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.28572;
  letter-spacing: 0.16px;
  position: relative;
  display: inline-flex;
  max-width: 20rem;
  min-height: 3rem;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: calc(0.875rem - 3px) 63px calc(0.875rem - 3px) 15px;
  margin: 0;
  border-radius: 0;
  cursor: pointer;
  outline: none;
  text-align: left;
  text-decoration: none;
  transition: background 70ms cubic-bezier(0, 0, 0.38, 0.9), box-shadow 70ms cubic-bezier(0, 0, 0.38, 0.9), border-color 70ms cubic-bezier(0, 0, 0.38, 0.9), outline 70ms cubic-bezier(0, 0, 0.38, 0.9);
  vertical-align: top;

  img {
    width: 1rem;
    height: 1rem;
  }

  a {
    color: inherit;
    text-decoration: inherit;
  }

  &.primary {
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    background-color: #0f62fe;
    color: #ffffff;

    &:hover {
      background-color: #0353e9;
    }

    &:active {
      background-color: #002d9c;
    }

    &:focus {
      border-color: #0f62fe;
      box-shadow: inset 0 0 0 1px #0f62fe, inset 0 0 0 2px #ffffff;
    }

    img {
      position: absolute;
      right: 1rem;
      flex-shrink: 0;

      &.left {
        left: 1rem;
      }

      &.right {
        right: 1rem;
      }
    }

    &:disabled {
      border-color: #c6c6c6;
      cursor: not-allowed;
      background-color: #c6c6c6;
      color: #8d8d8d;

      &:hover {
        background-color: #c6c6c6;
        border-color: transparent;
        color: #8d8d8d;
        outline: none;
      }
    }
  }

  &.ghost {
    border-width: 1px;
    border-style: solid;
    border-color: transparent;
    background-color: transparent;
    color: #0f62fe;
    padding: calc(0.875rem - 3px) 16px;

    &:hover {
      background-color: #e5e5e5;
    }

    &:active {
      background-color: #c6c6c6;
    }

    &:focus {
      border-color: #0f62fe;
      box-shadow: inset 0 0 0 1px #0f62fe, inset 0 0 0 2px #ffffff;
    }

    &:active,
    &:hover {
      color: #0043ce;
    }

    img {
      position: static;

      &.left {
        margin-right: 0.5rem;
      }

      &.right {
        margin-left: 0.5rem;
      }
    }

    &:disabled {
      color: #8d8d8d;
      cursor: not-allowed;

      &:hover {
        border-color: transparent;
        background: transparent;
        color: #8d8d8d;
        outline: none;
      }
    }
  }

}
</style>
